import { useNavigate } from "react-router-dom";

const ProjectActions = ({
  itemId,
  setItemId,
  item,
  setShowAdd,
  handleMarkComplete,
  setDeleteId,
  setShowDelete,
}) => {
  const navigate = useNavigate();
  const projectActionOptions = [
    { value: "view", label: "View" },
    { value: "edit", label: "Edit" },
    { value: "delete", label: "Delete" },
    { value: "mark_complete", label: "Mark Complete" },
  ];

  const handleChange = (selectedOption) => {
    setItemId(itemId);
    if (selectedOption === "raise_invoice") {
      navigate(`/invoices/add?project=${item?.project}&milestone=${item?.id}`);
    } else if (selectedOption === "view") {
      window.open(`/projects/${item?.id}`, "_blank");
      // navigate(`/projects/${item?.id}`);
    } else if (selectedOption === "mark_complete") {
      setItemId(itemId);
      handleMarkComplete(item);
    } else if (selectedOption === "edit") {
      setShowAdd(true);
    } else if (selectedOption === "delete") {
      setDeleteId(itemId);
      setShowDelete(true);
    }
  };

  const filteredOptions =
    item?.status === "COMPLETED"
      ? projectActionOptions.filter(
          (option) => option.value !== "mark_complete"
        )
      : projectActionOptions;

  return (
    <>
      <select
        value={""}
        onChange={(e) => handleChange(e.target.value)}
        style={{
          width: "120px",
          border: "0px",
          boxShadow: "0px",
          backgroundColor: "#EFF6FA",
          borderRadius: "5px",
          paddingRight: "0px",
          paddingLeft: "0px",
        }}
        className={`p-1 border fs-16 focus-none px-0`}
      >
        <option kay={""} value="" disabled>
          Select
        </option>
        {filteredOptions?.map((item, index) => (
          <option className="p-1" key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </>
  );
};

export default ProjectActions;
